import React,{useState} from "react";
import { useForm } from "react-hook-form";
import { Link, useParams,useNavigate } from "react-router-dom";
import { Form, Button, Label } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { HTTPURL, REQUEST_OPTIONS, REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";


const AddAssignment = () => 
{
    const [image, setImage] = useState({ preview: '', data: '' });
    const [pdf, setPdf] = useState({ preview: '', data: '' });
    const [video, setVideo] = useState({ preview: '', data: '' });
    const [lessAssgn, setlessAssgn] = useState({ preview: '', data: '' });
    let images = [];
    let files = [];
    let pdfName = [];
    let pdfFile = [];
    let videoName = [];
    let VideoFile = [];
    let lessonAssign = [];
    const navigate = useNavigate();
    
    const {
        register,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm();

    // code for images changes
    const handleFileChange = (e) => {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            images.push(URL.createObjectURL(e.target.files[i]));
            files.push(e.target.files[i]);
        }
        setImage({preview: images,data:files});
    }

    // code for pdf handler changes
    const pdfHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            pdfName.push(URL.createObjectURL(e.target.files[i]));
            pdfFile.push(e.target.files[i]);
        }
        setPdf({preview: pdfName,data:pdfFile});
    }

    // code for video handler changes
    const videoHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            videoName.push(URL.createObjectURL(e.target.files[i]));
            VideoFile.push(e.target.files[i]);
        }
        setVideo({preview: videoName,data:VideoFile});
    }

    // code for video handler changes
    const lessonAssHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            lessonAssign.push(e.target.files[i]);
        }
        setlessAssgn({preview: '',data:lessonAssign});
    }

    const onSubmit = () => 
    {
        let formData = new FormData()
        image.data.forEach(img => {
            formData.append('files', img);
        });
        pdf.data.forEach(sinPdf =>
        {
            formData.append('pdf_files', sinPdf);
        });
        video.data.forEach(signVido =>
        {
            formData.append('video_files', signVido);
        });
        lessAssgn.data.forEach(lessAssg =>
        {
            formData.append('lesson_assignment', lessAssg);
        });
        formData.append('courseName', getValues("courseName"));
        formData.append('lesson_name', getValues("lesson_name"));
        componentDidMount(formData);
    }

    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS_NO_HEAD.method = 'POST';
        REQUEST_OPTIONS_NO_HEAD.body = requestData;
        fetch(HTTPURL+'admin/add-assignment', REQUEST_OPTIONS_NO_HEAD)
        .then(async response => 
        {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
            if (!response.ok) 
            {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status === true)
            {
                setValue('courseName','');
                setValue('lesson_name','');
                setValue('image','');
                setValue('pdf','');
                setValue('video','');
                setValue('lesson_assignment','');
                setImage({preview: '',data:''});
                toast.success(data.message);
                navigate('/secure/assignments');
            }else{
                toast.error(data.message)
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }

    return (
        <div className="container rounded bg-white mt-5 mb-5">
                <div className="row">
                    <div className="col-md-2 border-right">
                        <div className="d-flex flex-column align-items-center text-center prf-img-set">
                            {
                                image.preview && image.preview.map((img,ind) => 
                                {
                                    return <img key={ind} src={img} className="rounded-circle mt-5" height="100px" width="100px" />;
                                })
                            }
                        </div>
                    </div>
                    <div className="col-md-7 border-right">
                        <div className="p-3 py-5">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="text-right">Add Assignment</h4>
                            </div>
                            <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <Form.Field>
                                                <label className="form-label" htmlFor="course name">Course Name:</label>
                                                <select
                                                    {...register("courseName", { required: true})}
                                                >
                                                    <option className="text-center" value="">Select Course</option>
                                                    <option className="text-center" value="1">Demo 1</option>
                                                    <option className="text-center" value="2">Demo 2</option>
                                                    <option className="text-center" value="3">Demo 3</option>
                                                    <option className="text-center" value="4">Demo 4</option>
                                                    <option className="text-center" value="5">Demo 5</option>
                                                </select>
                                        </Form.Field>
                                        {errors.courseName && errors.courseName.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Field>
                                                <label className="form-label" htmlFor="lesson name">Lesson Name:</label>
                                                <input
                                                    placeholder='lesson_name'
                                                    type="text"
                                                    {...register("lesson_name",{ required: true})}
                                                    className="form-control form-control-lg"
                                                />
                                            </Form.Field>
                                            {errors.lesson_name && errors.lesson_name.type === "required" && <span className="validation-error">This is required</span>}
                                        </div>
                                    </div>
                                    <hr/>
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <h6 className="form-label" htmlFor="course content">Lesson Resources:</h6>
                                        <Form.Field>
                                                <label className="form-label" htmlFor="image">Image:</label>
                                                <input
                                                    placeholder='image'
                                                    type="file"
                                                    {...register("image",{ required: true})}
                                                    className="form-control form-control-lg"
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                    multiple
                                                />
                                                <span> File Formats: png & jpg, jpeg.</span>
                                        </Form.Field>
                                        {errors.image && errors.image.type === "required" && <span className="validation-error">This is required</span>}
                                        <Form.Field>
                                                <label className="form-label" htmlFor="course name">Pdf:</label>
                                                <input
                                                    placeholder='Pdf'
                                                    type="file"
                                                    {...register("pdf",{ required: true})}
                                                    className="form-control form-control-lg"
                                                    onChange={pdfHandleFile}
                                                    accept=".pdf*"
                                                    multiple
                                                />
                                        </Form.Field>
                                        {errors.pdf && errors.pdf.type === "required" && <span className="validation-error">This is required</span>}
                                        <Form.Field>
                                                <label className="form-label" htmlFor="Video">Video:</label>
                                                <input
                                                    placeholder='Video'
                                                    type="file"
                                                    {...register("video")}
                                                    className="form-control form-control-lg"
                                                    onChange={videoHandleFile}
                                                    accept="video/*"
                                                    multiple
                                                />
                                        </Form.Field>
                                        {errors.video && errors.video.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>
                                </div>
                                <hr/>
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <h6 className="form-label" htmlFor="course name">Lesson Assignment:</h6>
                                        <Form.Field>
                                                {/* <label className="form-label" htmlFor="course name">All files :</label> */}
                                                <input
                                                    placeholder=''
                                                    type="file"
                                                    {...register("lesson_assignment",{ required: true})}
                                                    className="form-control form-control-lg"
                                                    onChange={lessonAssHandleFile}
                                                    multiple
                                                />
                                        </Form.Field>
                                        {errors.lesson_assignment && errors.lesson_assignment.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>
                                </div>
                                <div className="mt-3"><button className="btn btn-primary profile-button sap-btn-dark" type="submit">Add</button></div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default AddAssignment;